/** Sources whose content differs for every viewer, so an admin previewing as
 * someone else must not see the target's data. */
export const PERSONAL_COLLECTION_SOURCES = [
    'favorites',
    'recently-viewed',
];
export const isPersonalCollectionSource = (source) => PERSONAL_COLLECTION_SOURCES.includes(source);
export const DEFAULT_COLLECTION_LIMIT = 6;
export const MAX_COLLECTION_LIMIT = 24;
export const collectionSourceOf = (config) => config.source ?? 'manual';
export const collectionLimitOf = (config) => Math.min(config.limit ?? DEFAULT_COLLECTION_LIMIT, MAX_COLLECTION_LIMIT);
export const HOMEPAGE_RECOMMENDED_ACTION_SCOPES = {
    'connect-warehouse': 'organization',
    'add-semantic-layer': 'project',
    'connect-source-control': 'organization',
    'connect-slack': 'organization',
};
export const SKIPPABLE_HOMEPAGE_RECOMMENDED_ACTION_KEYS = [
    'add-semantic-layer',
    'connect-source-control',
    'connect-slack',
];
export const HOMEPAGE_MAX_BLOCKS_PER_ROW = 2;
export const defaultHomepageConfig = () => ({
    version: 1,
    rows: [
        {
            id: 'row-1',
            blocks: [
                {
                    id: 'block-1',
                    type: 'markdown',
                    config: {
                        content: '## Welcome\n\nEdit this homepage to get started.',
                    },
                },
            ],
        },
    ],
});
// `hero` (Greeting) is no longer a block type. Convert any legacy stored hero
// block into a markdown block so old configs still load, save and render — its
// {name} token keeps personalizing via the markdown block's own interpolation.
const migrateBlock = (block) => {
    if (block.type !== 'hero')
        return block;
    const legacyConfig = block.config;
    const title = typeof legacyConfig.title === 'string' ? legacyConfig.title : '';
    const subtitle = typeof legacyConfig.subtitle === 'string' ? legacyConfig.subtitle : '';
    const content = subtitle ? `## ${title}\n\n${subtitle}` : `## ${title}`;
    return { id: block.id, type: 'markdown', config: { content } };
};
export const migrateHomepageConfig = (config) => ({
    ...config,
    // A row the read-path sanitizer emptied (all its blocks unparseable) has
    // nothing left to edit or render — drop it rather than keep a ghost row.
    rows: config.rows
        .map((row) => ({
        ...row,
        blocks: row.blocks.map(migrateBlock),
    }))
        .filter((row) => row.blocks.length > 0),
});
/**
 * Curated announcement categories a data team uses to signal intent to
 * business users. Fixed set (not user-managed) — each maps to a label + colour
 * in `ANNOUNCEMENT_CATEGORY_META`.
 */
export var AnnouncementCategory;
(function (AnnouncementCategory) {
    /** Something new to use — a new dashboard, metric, or capability. */
    AnnouncementCategory["LAUNCH"] = "launch";
    /** Something changed — a metric definition or dashboard refresh. */
    AnnouncementCategory["UPDATE"] = "update";
    /** Something to be aware of — data delays, quality issues, maintenance. */
    AnnouncementCategory["HEADS_UP"] = "heads_up";
})(AnnouncementCategory || (AnnouncementCategory = {}));
export const ANNOUNCEMENT_CATEGORY_META = {
    [AnnouncementCategory.LAUNCH]: { label: 'Launch', color: 'green' },
    [AnnouncementCategory.UPDATE]: { label: 'Update', color: 'violet' },
    [AnnouncementCategory.HEADS_UP]: { label: 'Heads up', color: 'orange' },
};
/** Slack's markdown block rejects ~12k chars; cap bodies well under it */
export const ANNOUNCEMENT_BODY_MAX_LENGTH = 8000;
//# sourceMappingURL=types.js.map